var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-resumecheck-number-container",
      class: { "is-hide": _vm.checkedCount === 0 },
    },
    [
      _c("span", { staticClass: "boss-resumecheck-number" }, [
        _vm._v(_vm._s(_vm.checkedCount)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "boss-resumecheck-number-text" }, [
        _vm._v("名チェックされています"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }